export default "__VITE_ASSET__BasgAsEs__"